import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';

function baseStyleText(props: StyleFunctionProps) {
  return {
    color: mode('red.800', 'red.700')(props),
  };
}

function baseStyleIcon(props: StyleFunctionProps) {
  return {
    color: mode('red.800', 'red.700')(props),
  };
}

const baseStyle = (props: StyleFunctionProps) => ({
  text: baseStyleText(props),
  icon: baseStyleIcon(props),
});

export default {
  baseStyle,
};
